import DiverseEmojisOptions from '../store/schema/options/DiverseEmojisOptions';
import GdprAdsPrefsOptions from '../store/schema/options/GdprAdsPrefsOptions';
import OwsOptionsBase from '../store/schema/OwsOptionsBase';
import SkypeNotificationOptions from '../store/schema/options/SkypeNotificationOptions';
import SmartSuggestionsOptions from '../store/schema/options/SmartSuggestionsOptions';
import SurfaceActionsOptions from '../store/schema/options/SurfaceActionsOptions';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import ConfettiOptions from '../store/schema/options/ConfettiOptions';
import ComposeAssistanceOptions from '../store/schema/options/ComposeAssistanceOptions';
import { OwsOptionsFeatureType } from '../store/schema/OwsOptionsFeatureType';
import CalendarSurfaceAddinsOptions from '../store/schema/options/CalendarSurfaceAddinsOptions';
import ExternalImagesOptions from '../store/schema/options/ExternalImagesOptions';
import EventCaptureOptions from '../store/schema/options/EventCaptureOptions';
import LinkedInBindingDismissedOptions from '../store/schema/options/LinkedInBindingDismissedOptions';
import AmpDeveloperOptions from '../store/schema/options/AmpDeveloperOptions';
import { isFeatureEnabled } from 'owa-feature-flags';
import TranslationOptions from '../store/schema/options/TranslationOptions';
import CalendarSurfaceOptions from '../store/schema/options/CalendarSurfaceOptions';

export type DefaultOptionsType = { [key: number]: Partial<OwsOptionsBase> };

/**
 * These are the default options to use when we have successfully retrieved the user's options,
 * and they have not yet set any of the values for a given feature's options.
 * These are distinct from the "fail-safe" options specified in the default store value in store.ts
 */
export default function getDefaultOptions(): DefaultOptionsType {
    return {
        [OwsOptionsFeatureType.SmartSuggestions]: {
            smartSuggestionsEnabled: true,
            browserLocationEnabled: false,
        } as SmartSuggestionsOptions,
        [OwsOptionsFeatureType.DiverseEmojis]: {
            diverseEmojisSelectedSkinTone: '',
        } as DiverseEmojisOptions,
        [OwsOptionsFeatureType.SurfaceActions]: {
            readSurfaceActions: ['Reply', 'ReplyAll', 'Forward'].concat(
                !isConsumer() ? ['LikeUnlike'] : []
            ),
            readSurfaceAddins: [],
            composeSurfaceActions: [
                'AddAttachment',
                'AddInlineImage',
                'AddEmoji',
                'ToggleDictation',
                'ToggleRibbon',
            ],
            composeSurfaceAddins: [],
        } as SurfaceActionsOptions,
        [OwsOptionsFeatureType.SkypeNotifications]: {
            skypeMessageNotification: 1, // Toast and Sound
            skypeCallingNotification: 1, // Toast and Sound
        } as SkypeNotificationOptions,
        [OwsOptionsFeatureType.Confetti]: {
            confettiEnabled: true,
        } as ConfettiOptions,
        [OwsOptionsFeatureType.ComposeAssistance]: {
            composeAssistanceEnabled: true,
        } as ComposeAssistanceOptions,
        [OwsOptionsFeatureType.GdprAdsPrefs]: {
            feature: OwsOptionsFeatureType.GdprAdsPrefs,
            consentString: null,
            allowStorageAndAccess: false,
            allowPersonalization: false,
            allowAdSelectionDeliveryReporting: false,
            allowContentSelectionDeliveryReporting: false,
            allowMeasurement: false,
        } as GdprAdsPrefsOptions,
        [OwsOptionsFeatureType.CalendarSurfaceAddins]: {
            calendarSurfaceAddins: [],
        } as CalendarSurfaceAddinsOptions,
        [OwsOptionsFeatureType.ExternalImages]: {
            externalImagesSelectedOption: 0, //Display via image proxy
        } as ExternalImagesOptions,
        [OwsOptionsFeatureType.EventCapture]: {
            autoCollectionEnabled: false,
        } as EventCaptureOptions,
        [OwsOptionsFeatureType.LinkedInBindingDismissed]: {
            linkedInBindingDismissedInPeoplePicker: false,
        } as LinkedInBindingDismissedOptions,
        [OwsOptionsFeatureType.Translation]: {
            translationMode: 0,
            excludedLanguages: [],
        } as TranslationOptions,
        [OwsOptionsFeatureType.CalendarSurfaceOptions]: {
            agendaPaneIsClosed: false,
        } as CalendarSurfaceOptions,
        [OwsOptionsFeatureType.AmpDeveloper]: {
            enabled: isFeatureEnabled('rp-ampDefault'),
            allowedSender: [],
        } as AmpDeveloperOptions,
    };
}
